const SPEICHER_SCHLUESSEL = "ki-darstellung";
const VORGABE = { scheme: "SYSTEM", density: "COMPACT" };
const GUELTIGE_SCHEMATA = ["SYSTEM", "LIGHT", "DARK"];
const GUELTIGE_DICHTEN = ["COMPACT", "COMFORTABLE"];
function istColorScheme(wert) {
    return typeof wert === "string" && GUELTIGE_SCHEMATA.includes(wert);
}
function istDensity(wert) {
    return typeof wert === "string" && GUELTIGE_DICHTEN.includes(wert);
}
/**
 * Setzt Farbschema und Dichte am <html>-Element und legt eine Kopie im Browser ab,
 * damit die Seite beim nächsten Aufruf sofort richtig aufbaut und nicht kurz hell aufblitzt.
 * Die verbindliche Quelle bleibt der Benutzersatz in der Datenbank.
 */
export function applyTheme(scheme, density) {
    const wurzel = document.documentElement;
    if (scheme === "SYSTEM")
        wurzel.removeAttribute("data-ki-scheme");
    else
        wurzel.setAttribute("data-ki-scheme", scheme.toLowerCase());
    wurzel.setAttribute("data-ki-density", density.toLowerCase());
    const farbe = getComputedStyle(wurzel).getPropertyValue("--ki-surface").trim();
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", farbe);
    try {
        localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify({ scheme, density }));
    }
    catch {
        // Privater Modus oder blockierter Speicher — die Darstellung stimmt trotzdem.
    }
}
/**
 * Der zuletzt bekannte Stand, für den ersten Aufbau vor der Antwort des Servers — siehe
 * main.tsx, das dies vor dem ersten Zeichnen von React aufruft. Der Wert kommt aus
 * localStorage, also aus dem Browser: Er könnte fehlen, von einer älteren/neueren
 * Fassung stammen oder von Hand verändert worden sein. Jedes Feld wird deshalb einzeln
 * geprüft und bei einem unbrauchbaren Wert auf die Vorgabe zurückgesetzt, statt blind
 * übernommen zu werden — ein kaputtes Feld darf das andere, gültige Feld nicht mitreißen.
 */
export function readCachedTheme() {
    try {
        const roh = localStorage.getItem(SPEICHER_SCHLUESSEL);
        if (roh === null)
            return VORGABE;
        const geparst = JSON.parse(roh);
        if (typeof geparst !== "object" || geparst === null)
            return VORGABE;
        const kandidat = geparst;
        return {
            scheme: istColorScheme(kandidat.scheme) ? kandidat.scheme : VORGABE.scheme,
            density: istDensity(kandidat.density) ? kandidat.density : VORGABE.density,
        };
    }
    catch {
        return VORGABE;
    }
}
//# sourceMappingURL=applyTheme.js.map